import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { GetTopNewsProductsQueryResponse } from "../../types/GetTopNewsProducts";

/**
     * @link /api/ms-content-infoportal-backend/v1/publications/topNews/products
     */
export async function getTopNewsProducts (options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<GetTopNewsProductsQueryResponse>["data"]> {
    const { data: resData } = await client<GetTopNewsProductsQueryResponse>({
        method: "get",
        url: `/api/ms-content-infoportal-backend/v1/publications/topNews/products`,
        ...options
    });
    
    return resData;
};